module.exports = __webpack_public_path__ + "media/control_acceso/peatonal_manual-b4a48245.png";